var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUmrahHajj(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 195.716,
    height: 220.653,
    viewBox: "0 0 195.716 220.653",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7973",
    "data-name": "Group 7973",
    transform: "translate(23330.5 20073.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7972",
    "data-name": "Group 7972",
    transform: "translate(-23329 -20072)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3661",
    "data-name": "Rectangle 3661",
    width: 167.533,
    height: 167.533,
    transform: "translate(25.183 0)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3662",
    "data-name": "Rectangle 3662",
    d: "M29.54,0H192.716a0,0,0,0,1,0,0V217.653a0,0,0,0,1,0,0H29.54A29.54,29.54,0,0,1,0,188.114V29.54A29.54,29.54,0,0,1,29.54,0Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3663",
    "data-name": "Rectangle 3663",
    d: "M25.06,0H192.716a0,0,0,0,1,0,0V50.12a0,0,0,0,1,0,0H25.06A25.06,25.06,0,0,1,0,25.06v0A25.06,25.06,0,0,1,25.06,0Z",
    transform: "translate(0 167.533)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1671",
    "data-name": "Line 1671",
    x1: 87.088,
    transform: "translate(105.628 183.59)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1672",
    "data-name": "Line 1672",
    x1: 146.412,
    transform: "translate(46.303 201.403)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7971",
    "data-name": "Group 7971",
    transform: "translate(69.336 46.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39386",
    "data-name": "Path 39386",
    d: "M177.583,109.137,118,111.076l20,8.724,59.193-1.939Z",
    transform: "translate(-117.967 -109.137)",
    fill: "none",
    stroke: "#707070",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39387",
    "data-name": "Path 39387",
    d: "M117.96,171.4,118,111.457l20,8.724v64.785Z",
    transform: "translate(-117.96 -109.518)",
    fill: "none",
    stroke: "#707070",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39388",
    "data-name": "Path 39388",
    d: "M201.062,183.132l.062-63.5-59.193,1.939v64.785Z",
    transform: "translate(-121.897 -110.86)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39389",
    "data-name": "Path 39389",
    d: "M118,130.9l20,10.513,59.177-3.256.016,5.467L138,146.6l-20-10.778Z",
    transform: "translate(-117.967 -112.713)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39390",
    "data-name": "Path 39390",
    d: "M176.369,152.619v4.527l25.007-1.585v-4.327Z",
    transform: "translate(-127.553 -116.051)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39391",
    "data-name": "Path 39391",
    d: "M125,144.611l-3.807-2.412v3.3L125,148Z",
    transform: "translate(-118.491 -114.568)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39392",
    "data-name": "Path 39392",
    d: "M135.014,150.556l-3.807-2.412v3.3l3.807,2.5Z",
    transform: "translate(-120.135 -115.544)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1673",
    "data-name": "Line 1673",
    y2: 3.35,
    transform: "translate(8.52 31.22)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39393",
    "data-name": "Path 39393",
    d: "M166,181.741l-17.479,1.349V153.5L166,152.791Z",
    transform: "translate(-122.979 -116.307)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1674",
    "data-name": "Line 1674",
    y2: 21.232,
    transform: "translate(34.279 41.094)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmrahHajj);
export default __webpack_public_path__ + "static/media/Umrah_Hajj.e5feaf631c59be2dc93fc8b6d774646a.svg";
export { ForwardRef as ReactComponent };